module.exports = __webpack_public_path__ + "img/expodecor_sisal.3f19b7d9.jpg";